// extracted by mini-css-extract-plugin
module.exports = {"cardWithBgWrapper":"cards-module--cardWithBgWrapper--1sK0R","cardWithBg":"cards-module--cardWithBg--2TZKy"};